/**
 * Net Stableford points for a single hole.
 *
 *   stableford = par + strokes - score + 2
 *
 * Floors at 0 (no negative Stableford). `strokes` is the hole-stroke
 * allowance for the player (see `getHoleStrokes`). `score` is gross.
 */
export const getStablefordPoints = (
  par: number,
  score: number,
  strokes: number,
): number => {
  const sf = par + strokes - score + 2;
  return sf < 0 ? 0 : sf;
};
